export default {
  addItem: {
    position: 'fixed',
    right: 200,
    top: 35,
    zIndex: 1,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  headerCol: {
    color: 'black',
    fontWeight: 'bold',
  },
  contactNameCol: {
    width: 170,
  },
  checkbox: { top: '16px',
    left: '12px',
    width: '24px',
  },
  selectedCount: {
    height: 'inherit',
    width: '100px',
    top: '0px',
    position: 'absolute',
    left: '53px',
    paddingTop: '18px',
  },
  editBut: {
    top: '10px',
    position: 'absolute',
    left: '155px',
    color: 'rgb(3, 169, 244)',
  },
  deleteBut: {
    top: '10px',
    position: 'absolute',
    left: '260px',
    color: 'rgb(3, 169, 244)',
  },
  createBut: {
    top: '10px',
    position: 'absolute',
    left: '390px',
    color: 'rgb(3, 169, 244)',
  },
  header: {
    marginTop: '70px',
  },
  wrapper: {
    marginTop: 20,
    marginBottom: 80,
  },
  chip: {
    // display: 'inline-block',
    float: 'left',
    marginRight: 2,
    marginTop: 2,
    marginBottom: 2,
  },
};



// WEBPACK FOOTER //
// ./src/components/Customers/CustomersView/styles.js